export default __webpack_public_path__ + "static/media/July_06.3d55876d.png";